import * as React from "react";
import { useState, useEffect } from "react";
import { decode } from "html-entities";
import { useSelector } from "react-redux";

import { getOnlineNode } from "../../../core/getNode";
import { alertMessages } from "../../../partials/alertMessages";
import { useEmailDataContext } from "../../../partials/dataContext";
import PresentationItem from "./PresentationItem";
import SelectedPresentationItem from "./SelectedPresentationItem";
import { paginator } from "../../../core/paginator";
import Pagination from "../../../partials/Pagination";
import MessageBox from "../../../partials/MessageBox";
import LoadingSpinner from "../../../partials/loading";
import { getContentTypeByBundle, getTemplateByIdentity } from "../../../utils/helpers";

import {
  Alert,
  FormControl,
  InputAdornment,
  MenuItem,
  Pagination as MuiPagination,
  TextField,
  Select,
  Input,
  InputLabel,
  Button,
} from "@mui/material";
import { SearchOutlined, ChevronLeft, ChevronRight } from "@mui/icons-material";
import { NestedMenuItem } from "mui-nested-menu";

export default function Presentations(props) {
  const [presentationIdOrTitle, setPresentationIdOrTitle] = useState("");
  const [presentationIdOrSita, setPresentationIdOrSita] = useState("");
  const [presentationAuthorName, setPresentationAuthorName] = useState("");
  const [presentationLibrary, setPresentationLibrary] = useState(0);
  const [presentationCategory, setPresentationCategory] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isPaginating, setIsPaginating] = useState(false);
  const [isError, setIsError] = useState(false);

  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [index, setIndex] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [categories, setCategories] = useState([]);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [libraries, setLibraries] = useState([
    { value: 0, label: "All Libraries" },
    { value: "user_library", label: "My library" },
    { value: "shared_library", label: "Shared library" },
    { value: "core_library", label: "Corporate library" },
  ]);
  const [selectedPresentationItems, setSelectedPresentationItems] = useState([]);

  const [data, setData] = useState([]);

  const [messageBoxVisible, setMessageBoxVisible] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageTitle, setMessageTitle] = useState("");
  const [messageBody, setMessageBody] = useState("");

  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("user")));

  const { selectedTemplate, contentTypeSelected, setPresentationsObject } = useEmailDataContext();

  // redux
  const system = useSelector((state) => state.systemReducer);
  const config = useSelector((state) => state.configReducer);
  const templateData = getTemplateByIdentity(selectedTemplate, config.templates);
  const contentTypeData = getContentTypeByBundle(contentTypeSelected, templateData.contentTypes);

  // hooks
  const access_token = useSelector((state) => state.authReducer);

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    getContent();
  }, [currentPage]);

  useEffect(() => {
    updatePresentationItemsView();
  }, [presentationIdOrTitle, presentationIdOrSita, presentationAuthorName, presentationLibrary, presentationCategory]);

  useEffect(() => {
    if (selectedPresentationItems.length > 0) {
      setPresentationsObject(selectedPresentationItems.map((item) => item.id));
    } else {
      setPresentationsObject([]);
    }
  }, [selectedPresentationItems]);

  const messageBoxState = (visible, type, title, body) => {
    setMessageBoxVisible(visible);
    setMessageType(type);
    setMessageTitle(title);
    setMessageBody(body);
  };

  const getCategories = () => {
    setIsLoading(true);

    // getOnlineNode("all_categories/presentation_categories")
    getOnlineNode("api/categories?vid=presentation_categories&used=1")
      .then((response) => {
        renderCategories(response.data);
      })
      .catch((_error) => {
        if (_error.response) {
          messageBoxState(true, "error", "Error", _error.response.statusText);
        } else if (_error.request) {
          messageBoxState(true, "error", "Error", alertMessages.requestError.message);
        } else {
          messageBoxState(true, "error", "Error", alertMessages.unknownError.message);
        }
        setIsLoading(false);
      });
  };

  const renderCategories = (_data) => {
    let _categories = [
      {
        value: 0,
        label: "--- All ---",
      },
    ];

    _data.forEach((item) => {
      if (item.has_view_permission === true) {
        _categories.push({
          value: item.tid,
          label: item.title,
          parent_target_id: item.parent_target_id,
        });
      }
    });

    setCategories(_categories);
  };

  const hasChildren = (id) => {
    if (categories) {
      const nested = categories.filter((item) => item.parent_target_id === id);

      if (nested.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  };

  const getChildItems = (arr, id) => {
    return arr.filter((item) => item.parent_target_id === id);
  };

  const getContent = () => {
    setIsLoading(true);
    messageBoxState(false, "", "", "");

    const path =
      "api/user_presentations?status=true" +
      "&items_per_page=" +
      pageSize +
      "&page=" +
      (currentPage ? currentPage - 1 : 0) +
      (presentationIdOrTitle && presentationIdOrTitle !== "" ? "&id_or_title=" + presentationIdOrTitle : "") +
      (presentationIdOrSita && presentationIdOrSita !== "" ? "&id_or_sita=" + presentationIdOrSita : "") +
      (presentationAuthorName && presentationAuthorName !== "" ? "&author_name=" + presentationAuthorName : "") +
      (presentationLibrary && presentationLibrary !== 0 ? "&library=" + presentationLibrary : "") +
      (presentationCategory && presentationCategory !== 0 ? "&category=" + presentationCategory : "");

    getOnlineNode(path)
      .then((response) => {
        setData(response.data.rows);
        setTotalItems(response.data.pager.total_items);
        setIsLoading(false);
        setIsRefreshing(false);
        setIsPaginating(false);
      })
      .catch((_error) => {
        if (_error.response) {
          messageBoxState(true, "error", "Error", _error.response.statusText);
        } else if (_error.request) {
          messageBoxState(true, "error", "Error", alertMessages.requestError.message);
        } else {
          messageBoxState(true, "error", "Error", alertMessages.unknownError.message);
        }
        setIsLoading(false);
      });
  };

  const addSelectedPresentationItem = (presentation) => {
    setSelectedPresentationItems((prevItems) => {
      const exists = prevItems.some((item) => item.id === presentation.id);
      if (exists) {
        return prevItems.filter((item) => item.id !== presentation.id); // Remove item
      } else {
        return [...prevItems, presentation]; // Add item
      }
    });
  };

  const removeSelectedPresentationItem = (presentation) => {
    setSelectedPresentationItems((prevItems) => prevItems.filter((item) => item.id !== presentation.id));
  };

  const renderPagination = () => {
    if (data.length && data.length > 0) {
      return (
        <Pagination
          containerClasses={`presentations-pagination d-flex justify-content-center align-items-center`}
          previousDisabled={currentPage === 1 ? true : false}
          nextDisabled={data?.length < pageSize ? true : false}
          currentPage={currentPage}
          onPrevious={() => {
            const current = currentPage - 1;
            setCurrentPage(current);
          }}
          onNext={() => {
            const current = currentPage + 1;
            setCurrentPage(current);
          }}
        />
      );
    }
  };

  const resetFilters = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setPresentationIdOrTitle("");
    setPresentationIdOrSita("");
    setPresentationAuthorName("");
    setPresentationLibrary(0);
    setPresentationCategory(0);
  };

  const updatePresentationItemsView = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (currentPage === 1) {
      getContent();
    } else {
      setCurrentPage(1);
    }
  };

  const removeAllSelectedPresentationItems = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    setSelectedPresentationItems([]);
  };

  const decodeHtmlEntities = (label) => {
    let item = label;

    try {
      item = decode(item);
    } catch (error) {
      // console.log('Cannot decode categories');
      return label;
    }

    return item;
  };

  const input_font_size = 14;
  const menuItemStyle = {
    fontSize: input_font_size,
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: "28px",
  };
  const nestedMenuItemStyle = {
    minHeight: "28px",
    fontSize: input_font_size,
    padding: "0 8px",
    "& .MuiTypography-root": {
      fontSize: input_font_size,
    },
  };
  const categoryList = categories.map((category) => {
    const has_child = hasChildren(category.value);
    const is_top_level = category.parent_target_id ? false : true;
    const menuProps = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      PaperProps: { style: { pointerEvents: "auto" } },
    };
    const menuProps2nd = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      PaperProps: { style: { pointerEvents: "auto" } },
    };
    const menuProps3rd = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right",
      },
      PaperProps: { style: { pointerEvents: "auto" } },
    };

    if (is_top_level) {
      if (has_child) {
        const region_child_items = getChildItems(categories, category.value);

        return (
          <NestedMenuItem
            key={`category-${category.value}`}
            leftIcon={null}
            rightIcon={
              <ChevronRight
                sx={{
                  height: "21px",
                }}
              />
            }
            parentMenuOpen={open}
            label={category.label}
            MenuProps={menuProps}
            className="filter-nested"
            sx={nestedMenuItemStyle}
          >
            {region_child_items.map((region) => {
              const countries = getChildItems(categories, region.value);

              return (
                <NestedMenuItem
                  key={`region-${region.value}`}
                  leftIcon={
                    <ChevronLeft
                      sx={{
                        height: "21px",
                      }}
                    />
                  }
                  onClick={() => {
                    setPresentationCategory(region.value);
                    setCategoryOpen(false);
                  }}
                  rightIcon={null}
                  parentMenuOpen={open}
                  label={region.label}
                  MenuProps={menuProps2nd}
                  className="filter-nested"
                  sx={nestedMenuItemStyle}
                >
                  {countries.map((country) => {
                    const cities = getChildItems(categories, country.value);

                    return (
                      <NestedMenuItem
                        key={`country-${country.value}`}
                        leftIcon={
                          <ChevronLeft
                            sx={{
                              height: "21px",
                            }}
                          />
                        }
                        rightIcon={null}
                        onClick={(e) => {
                          setPresentationCategory(country.value);
                          setCategoryOpen(false);
                        }}
                        parentMenuOpen={open}
                        label={country.label}
                        MenuProps={menuProps3rd}
                        className="filter-nested"
                        sx={nestedMenuItemStyle}
                      >
                        {cities.map((city, cityIndex) => {
                          return (
                            <MenuItem
                              key={`city-${city.value}`}
                              value={city.value}
                              sx={menuItemStyle}
                              onClick={(e) => {
                                setPresentationCategory(e.target.value);
                                setCategoryOpen(false);
                              }}
                            >
                              {decode(city.label)}
                              {/* {city.label} */}
                            </MenuItem>
                          );
                        })}
                      </NestedMenuItem>
                    );
                  })}
                </NestedMenuItem>
              );
            })}
          </NestedMenuItem>
        );
      } else {
        return (
          <MenuItem
            key={`category-${category.value}`}
            value={category.value}
            sx={menuItemStyle}
            onClick={(e) => {
              setPresentationCategory(e.target.value);
            }}
          >
            {decode(category.label)}
            {/* {category.label} */}
          </MenuItem>
        );
      }
    } else {
      return (
        <MenuItem
          key={`category-${category.value}`}
          value={category.value}
          sx={{ display: "none" }}
          onClick={(e) => {
            setPresentationCategory(e.target.value);
          }}
        >
          {/* {category.label} */}
          {decode(category.label)}
        </MenuItem>
      );
    }
    // <MenuItem sx={{ fontSize: "14px" }} value={category.value}>
    //   {category.label}
    // </MenuItem>
  });

  const renderLibraryList = libraries.map((library, index) => (
    <MenuItem key={`menu-item-${index}`} sx={menuItemStyle} value={library.value}>
      {library.label}
    </MenuItem>
  ));

  return (
    <div className="presentations-view-wrapper">
      {isLoading && (
        <div
          className="w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ position: "absolute", top: 0, left: 0, backgroundColor: "rgba(255,255,255,0.5)", zIndex: 9999 }}
        >
          <LoadingSpinner />
        </div>
      )}

      <div className="message-box-wrapper">
        <MessageBox
          messageBoxVisible={messageBoxVisible}
          messageTitle={messageTitle}
          messageBody={messageBody}
          setMessageBoxVisible={setMessageBoxVisible}
        />
      </div>

      <div className="presentations-form-filters-wrapper">
        <div className="available-presentations-title">
          <span>Choose presentation(s)</span>
        </div>
        <form className="filter-form" onSubmit={updatePresentationItemsView}>
          <div className="form-item-wrapper input title">
            <FormControl size="small" className="filter-input">
              <TextField
                id="title"
                label="Title"
                sx={{
                  "& label.Mui-focused": {
                    color: "#1976d2",
                    fontWeight: "600",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "#d2d0cf",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#d2d0cf",
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#d2d0cf",
                    },
                  },
                }}
                variant="outlined"
                value={presentationIdOrTitle}
                size="small"
                placeholder="Search title"
                onChange={(e) => {
                  setPresentationIdOrTitle(e.target.value);
                }}
                InputProps={{
                  style: { fontSize: "14px" },
                }}
                InputLabelProps={{ style: { fontSize: "14px" } }}
              />
            </FormControl>
          </div>
          <div className="form-item-wrapper input sita">
            <FormControl size="small" className="filter-input">
              <TextField
                id="title"
                label={system?.reference_enabled ? "ID / Reference" : "ID / SITA"}
                sx={{
                  "& label.Mui-focused": {
                    color: "#1976d2",
                    fontWeight: "600",
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: "#d2d0cf",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: "#d2d0cf",
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderColor: "#d2d0cf",
                    },
                  },
                }}
                variant="outlined"
                value={presentationIdOrSita}
                size="small"
                placeholder={system?.reference_enabled ? "ID or Reference" : "ID or SITA"}
                onChange={(e) => {
                  setPresentationIdOrSita(e.target.value);
                }}
                InputProps={{
                  style: { fontSize: "14px" },
                }}
                InputLabelProps={{ style: { fontSize: "14px" } }}
              />
            </FormControl>
          </div>
          {/*<div className="form-item-wrapper input">
              <FormControl size="small" className="filter-input">
                <TextField
                  id="title"
                  label="Author"
                  sx={{
                    "& label.Mui-focused": {
                      color: "#1976d2",
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#d2d0cf",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#d2d0cf",
                    },
                    "& .MuiOutlinedInput-root": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#d2d0cf",
                      },
                    },
                  }}
                  variant="outlined"
                  value={presentationAuthorName}
                  size="small"
                  placeholder="Search Author"
                  onChange={(e) => {
                    setPresentationAuthorName(e.target.value);
                  }}
                  InputProps={{
                    style: { fontSize: "14px" },
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchOutlined
                          sx={{
                            width: "20px",
                            height: "20px",
                            marginBottom: "5px",
                            marginRight: "8px",
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  InputLabelProps={{ style: { fontSize: "14px" } }}
                />
              </FormControl>
            </div>*/}
          <div className="form-item-wrapper select library">
            <FormControl className="filter-select" size="small">
              <InputLabel sx={{ fontSize: "14px" }} size="small" id="library-select-label">
                Library
              </InputLabel>
              <Select
                labelId="library-select-label"
                id="library-select"
                value={presentationLibrary == 0 ? "" : presentationLibrary}
                label="Library"
                sx={{
                  fontSize: "14px",
                }}
                onChange={(e) => {
                  setPresentationLibrary(e.target.value);
                }}
              >
                {renderLibraryList}
              </Select>
            </FormControl>
          </div>
          <div className="form-item-wrapper select category">
            <FormControl className="filter-select" size="small">
              <InputLabel sx={{ fontSize: "14px" }} size="small" id="category-select-label">
                Category
              </InputLabel>
              <Select
                labelId="category-select-label"
                id="category-select"
                value={presentationCategory == 0 ? "" : presentationCategory}
                open={categoryOpen}
                onClose={() => setCategoryOpen(false)}
                onOpen={() => setCategoryOpen(true)}
                label="Category"
                sx={{
                  fontSize: "14px",
                }}
                onChange={(e) => {
                  setPresentationCategory(e.target.value);
                }}
              >
                {categoryList}
              </Select>
            </FormControl>
          </div>
          <div className="form-item-wrapper apply reset">
            <div className="form-submit-wrapper form-button-wrapper form-control-wrapper">
              <Button
                type="submit"
                onClick={resetFilters}
                variant="outlined"
                sx={{
                  borderColor: "#1d9bf1",
                  color: "#1d9bf1",
                  lineHeight: "14px",
                  height: "35px",
                  width: "100%",
                  fontWeight: "500",
                  fontSize: "14px",
                  textTransform: "none",
                }}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="form-item-wrapper apply confirm">
            <div className="form-submit-wrapper form-button-wrapper form-control-wrapper">
              <Button
                type="submit"
                onClick={updatePresentationItemsView}
                variant="contained"
                sx={{
                  backgroundColor: "#1d9bf1",
                  width: "100%",
                  lineHeight: "14px",
                  height: "35px",
                  fontWeight: "500",
                  fontSize: "14px",
                  textTransform: "none",
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </form>
      </div>

      <div id="presentations-view-content" className="presentations-view-content">
        <div className="presentation-items-wrapper">
          <div id="presentation-items">
            {data.length > 0 ? (
              <>
                {data.map((presentation, index) => (
                  <PresentationItem
                    key={`pres-${index}-item`}
                    title={presentation.title}
                    id={presentation.id}
                    selectedPresentations={selectedPresentationItems}
                    firstSlide={presentation.slides.length > 0 ? presentation.slides[0].id : undefined}
                    presentationCustomThumbnail={presentation?.json?.thumbnail?.field_media_image}
                    slideCustomThumbnail={presentation?.slides[0]?.slideThumbnail?.field_media_image}
                    addSelectedPresentationItem={(presentation) => addSelectedPresentationItem(presentation)}
                    removeSelectedPresentationItem={(presentation) => removeSelectedPresentationItem(presentation)}
                    presentation={presentation}
                  />
                ))}
              </>
            ) : (
              <div className="presentation-items-alert-container">
                <Alert severity="warning" className="presentation-items-alert">
                  No presentations available for this search criteria. Click the 'Reset' button and try a different
                  search.
                </Alert>
              </div>
            )}
          </div>
          <div className="">{renderPagination()}</div>
        </div>
        <div className="selected-presentations-header-wrapper">
          <span>Selected Presentations</span>
          {selectedPresentationItems.length > 0 ? (
            <Button
              variant="outlined"
              size="small"
              sx={{
                textTransform: "none",
                fontSize: "14px",
              }}
              className="selected-presentations-clear-all-button"
              onClick={() => removeAllSelectedPresentationItems()}
            >
              Clear all
            </Button>
          ) : null}
        </div>
        <div id="presentation-items-selected-by-user-wrapper" className="presentation-items-selected-by-user-wrapper">
          <div id="presentation-items-selected-by-user" className="presentation-items-selected-by-user">
            {selectedPresentationItems.length > 0 ? (
              ""
            ) : (
              <>
                <h5 className="instruction title">INSTRUCTIONS</h5>
              </>
            )}
            {selectedPresentationItems.length > 0 ? (
              <>
                {selectedPresentationItems.map((presentation, index) => (
                  <SelectedPresentationItem
                    key={`selected-pres-item-${index}`}
                    removeSelectedPresentationItem={(presentation) => removeSelectedPresentationItem(presentation)}
                    presentation={presentation}
                  />
                ))}
              </>
            ) : (
              <>{contentTypeData.help && <>{contentTypeData.help}</>}</>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
